import { render } from "./BaseToolTip.vue?vue&type=template&id=18b445f3&scoped=true"
const script = {}

import "./BaseToolTip.vue?vue&type=style&index=0&id=18b445f3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b445f3"]])

export default __exports__